import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import ItemPartViewState from '../../store/schema/ItemPartViewState';
import datapoints from '../../datapoints';

export default createLegacyActionWithDatapoint(
    'toggleCalendarRollUpItemPartExpanded',
    datapoints.ToggleCalendarRollUpItemPartExpanded
)(function toggleCalendarRollUpItemPartExpanded(itemPartViewState: ItemPartViewState) {
    if (
        itemPartViewState?.isInRollUp &&
        itemPartViewState.calendarRollUpViewState.isCalendarResponse
    ) {
        itemPartViewState.isExpanded = !itemPartViewState.isExpanded;
    }
});
